import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components'

import minimizeIcon from '../../assets/icons/minimize.svg'

import Image from '../shared/image'

import { toggleMinimizedApp } from '../../duck/operations'

const MinimizeIconContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  &:hover {
    background-color: rgba(204, 204, 204, 0.5);
  }
  &:active {
    opacity: 0.95;
  }
`

const MinimizeIcon = styled(Image).attrs({
  src: minimizeIcon
})`
  border-radius: 50%;
`

export const MinimizerComponent = (props) => (
  <MinimizeIconContainer>
    <MinimizeIcon
      onClick={props.toggleMinimizedApp}
    />
  </MinimizeIconContainer>
)

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators( { toggleMinimizedApp }, dispatch)
}

const Minimizer = connect(undefined, mapDispatchToProps)(MinimizerComponent)
export default Minimizer



// WEBPACK FOOTER //
// ./src/components/shared/minimizer.js